import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

const navItems = [
  { label: "Home", path: "/" },
  { label: "Our Collection", path: "/packages" },
  { label: "About", path: "/about" },
  { label: "Contact", path: "/contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-dark-bg/95 backdrop-blur-md border-b border-dark-border"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link to="/" className="flex flex-col items-center leading-none group">
            <span className="font-serif text-xl md:text-2xl font-bold tracking-[0.12em] text-gold transition-colors duration-300">
              PROPRE
            </span>
            <span className="font-serif text-xs md:text-sm font-normal tracking-[0.25em] text-gold -mt-0.5">
              Purification
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-sm font-sans font-medium tracking-wide transition-colors duration-300 whitespace-nowrap ${
                  location.pathname === item.path
                    ? "text-gold"
                    : "text-charcoal-300 hover:text-gold"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden md:block">
            {location.pathname !== "/contact" ? (
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-gold text-dark-bg text-sm font-sans font-semibold rounded-full hover:bg-gold-light transition-colors duration-300 whitespace-nowrap"
              >
                Inquire
                <i className="ri-arrow-right-line text-xs"></i>
              </Link>
            ) : (
              <div className="inline-flex items-center gap-2 px-5 py-2.5 invisible whitespace-nowrap">
                Inquire
                <i className="ri-arrow-right-line text-xs"></i>
              </div>
            )}
          </div>

          {/* Mobile Hamburger */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-gold"
            aria-label="Toggle menu"
          >
            <i className={`ri-${mobileOpen ? "close" : "menu"}-line text-xl`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden absolute top-full left-0 right-0 bg-dark-bg/98 backdrop-blur-md border-t border-dark-border transition-all duration-300 ${
          mobileOpen
            ? "opacity-100 translate-y-0"
            : "opacity-0 -translate-y-2 pointer-events-none"
        }`}
      >
        <div className="px-6 py-6 flex flex-col gap-4">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`text-base font-sans font-medium py-2 ${
                location.pathname === item.path
                  ? "text-gold"
                  : "text-charcoal-300"
              }`}
            >
              {item.label}
            </Link>
          ))}
          {location.pathname !== "/contact" && (
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 px-5 py-3 bg-gold text-dark-bg text-sm font-sans font-semibold rounded-full mt-2 whitespace-nowrap"
            >
              Inquire
              <i className="ri-arrow-right-line text-xs"></i>
            </Link>
          )}
        </div>
      </div>
    </nav>
  );
}